var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-line line",class:{ 'line--small': _vm.isSmall },attrs:{"data-animation":_vm.isAnimated ? 'line' : false}})}
var staticRenderFns = []

export { render, staticRenderFns }